import { useEffect, useRef } from 'react';

import { getEcho, leaveChannel } from 'services/socket';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Payload = any;
type ListenCb = (payload: Payload) => void;

type UseSocketOptions = {
  channel: string;
  event?: string;
  callback: ListenCb;
  isPrivate?: boolean;
  enabled?: boolean;
};

export function useSocket({
  channel,
  event = '*',
  callback,
  isPrivate = true,
  enabled = true,
}: UseSocketOptions): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!enabled) {
      leaveChannel(channel);
      return undefined;
    }

    const echo = getEcho();
    const channelInstance = isPrivate
      ? echo.private(channel)
      : echo.channel(channel);

    if (event === '*') {
      // @ts-expect-error - listenToAll missing from Echo types
      channelInstance.listenToAll((_: string, payload: Payload) =>
        callbackRef.current(payload),
      );
    } else {
      channelInstance.listen(event, (payload: Payload) =>
        callbackRef.current(payload),
      );
    }

    return () => {
      leaveChannel(channel);
    };
  }, [channel, event, isPrivate, enabled]);
}
